// extracted by mini-css-extract-plugin
export default {"titleDate":"VigboRenewRemindinfo__titleDate--1LdH5"};